module.exports = __webpack_public_path__ + "videos/animationassist-cn.a3fcba4.mp4";